// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fjQ7","footer":"styles_footer__lO87a"};